import { render, staticRenderFns } from "./approval-history.vue?vue&type=template&id=6cbc7cf5&scoped=true&"
import script from "./approval-history.vue?vue&type=script&lang=js&"
export * from "./approval-history.vue?vue&type=script&lang=js&"
import style0 from "./approval-history.vue?vue&type=style&index=0&id=6cbc7cf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc7cf5",
  null
  
)

export default component.exports